import { useMemo } from 'react'

import _ from 'lodash'
import { useFormContext, useWatch } from 'react-hook-form'

import { useLevelPlaySurface } from '@/shared/level-play'

import { useBorderColor } from '../../hooks/useBorderColor'

export const LevelPlayThisOrThat = ({
  activity
}) => {
  const { setValue } = useFormContext()
  const { isSubmitting, disableInputs } = useLevelPlaySurface()
  const { getBorderColor } = useBorderColor()
  const { meta } = activity
  const associations = useMemo(
    () => _.shuffle(meta?.associations || []),
    [meta]
  )
  const watchAnswer = useWatch({ name: 'answer', defaultValue: '' })

  const toggleSelect = association => {
    if (isSubmitting || disableInputs) return

    if (watchAnswer != association.name) setValue('answer', association.name)
  }

  return (
    <div className="grid gap-2 w-full grow mx-auto grid-cols-2">
      {associations.map((association, index) => {
        const isSelected = watchAnswer == association.name
        const borderColor = getBorderColor({
          hasSelection: true,
          isSelected
        })

        return (
          <div
            key={`association-${index}`}
            className={`overflow-hidden border-3 rounded-xl cursor-pointer ${borderColor}`}
            onClick={() => toggleSelect(association)}
          >
            {association?.image ? (
              <div className="flex flex-col items-center">
                <div className="aspect-square w-full rounded-t-lg overflow-hidden">
                  <img
                    src={_.get(association, 'image.file.url')}
                    className="object-cover object-center bg-white block w-full h-full"
                    style={{ pointerEvents: 'none' }}
                    alt=""
                  />
                </div>
                <span
                  className="text-gray-800 font-extrabold text-sm md:text-lg w-full text-center block p-4"
                  style={{
                    wordBreak: 'break-word'
                  }}
                >
                  {_.get(association, 'name')}
                </span>
              </div>
            ) : (
              <span
                className="text-gray-800 font-extrabold text-sm md:text-lg w-full text-center block p-4 min-h-[100px] h-full flex flex-col items-center justify-center"
                style={{
                  wordBreak: 'break-word'
                }}
              >
                {_.get(association, 'name')}
              </span>
            )}
          </div>
        )
      })}
    </div>
  )
}
